import type { RouteLocationNormalized, RouteRecordRaw } from "vue-router";
import type { AbilitiesEvaluation } from "vue-simple-acl/types/acl";
import { BREADCRUMBS } from "~/core/constants/breadcrumbs";
import { ACLRoles } from "~/core/models/ACLRoles.enum";
import { canWithRedirection } from "~/core/utils/canWithRedirection";
import {
  PATH_PARAMETERS_APPLICATIONS,
  PATH_PARAMETERS_APPLICATIONS_THIRD_PART_APP,
  PATH_PARAMETERS_APPLICATIONS_THIRD_PART_APP_CLIENT_ID,
} from "~/modules/applicationManagement/constants";
import ApplicationMgtPage from "~/modules/applicationManagement/views/ApplicationMgtPage.vue";

const routes: RouteRecordRaw[] = [
  {
    path: PATH_PARAMETERS_APPLICATIONS,
    component: ApplicationMgtPage,
    meta: {
      can: (
        _to: RouteLocationNormalized,
        _from: RouteLocationNormalized,
        can: AbilitiesEvaluation,
      ) => canWithRedirection(can, ACLRoles.CAN_READ_APPLICATION),
      breadcrumb: BREADCRUMBS.PARAMETERS,
    },
  },
  {
    path: PATH_PARAMETERS_APPLICATIONS_THIRD_PART_APP,
    component: ApplicationMgtPage,
    meta: {
      can: (
        _to: RouteLocationNormalized,
        _from: RouteLocationNormalized,
        can: AbilitiesEvaluation,
      ) => canWithRedirection(can, ACLRoles.CAN_READ_APPLICATION),
      breadcrumb: BREADCRUMBS.PARAMETERS,
    },
  },
  {
    path: PATH_PARAMETERS_APPLICATIONS_THIRD_PART_APP_CLIENT_ID,
    component: ApplicationMgtPage,
    meta: {
      can: (
        _to: RouteLocationNormalized,
        _from: RouteLocationNormalized,
        can: AbilitiesEvaluation,
      ) => canWithRedirection(can, ACLRoles.CAN_READ_APPLICATION),
      breadcrumb: BREADCRUMBS.PARAMETERS,
    },
  },
];

export default routes;
